import { MenuItem, Text } from "@chakra-ui/react"
import useAddToList from "../../../../../../common/hooks/useAddToList"
import { useBrandedTranslation } from "../../../../../../common/hooks/useBrandedTranslation"
import CustomTooltip from "../../../../../shared/CustomTooltip"
import LoadingIcon from "../../../../../shared/DownloadButton/LoadingIcon"
import { CAddToList, CAddedToList } from "../../../../../shared/Icons"

const AddArticleMenuItem = ({ articleCode }) => {
  const { t } = useBrandedTranslation()
  const { addToList, isBeingAdded, isAdded, isAtArticleLimit } = useAddToList(articleCode)

  const handleAddToList = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    addToList()
  }

  return (
    <CustomTooltip label={isAtArticleLimit ? t("acc-myLists-articleLimit-tooltip") : ""} maxW="-moz-max-content">
      <MenuItem
        icon={isBeingAdded ? <LoadingIcon /> : isAdded ? <CAddedToList /> : <CAddToList />}
        isDisabled={isAtArticleLimit || isBeingAdded}
        onClick={handleAddToList}
        aria-label="Add article to list"
      >
        <Text fontWeight="medium">{t(isAdded ? "wishlist-add-confirmation" : "wishlist-add-article")}</Text>
      </MenuItem>
    </CustomTooltip>
  )
}

export default AddArticleMenuItem
